import { RoiSetting } from '../../../../../../models/measure/roi-report';
import { CommonConstant } from '../../../../../app.constants';
var RoiSettingComponent = /** @class */ (function () {
    function RoiSettingComponent() {
        this.calculationMethods = CommonConstant.CPM_CALCULATION_METHODS;
        this.currencies = CommonConstant.CURRENCIES;
    }
    Object.defineProperty(RoiSettingComponent.prototype, "selectedCurrency", {
        get: function () {
            if (!this.roiSetting) {
                return '';
            }
            switch (this.roiSetting.currency) {
                case 0:
                    return '€';
                case 1:
                    return '$';
                case 2:
                    return CommonConstant.DANISH_KRONE_CURRENCY;
                case 3:
                    return CommonConstant.NORWAY_CURRENCY;
                case 4:
                    return CommonConstant.SWEDISH_CURRENCY;
                case 5:
                    return CommonConstant.POUND_CURRENCY;
            }
        },
        enumerable: true,
        configurable: true
    });
    return RoiSettingComponent;
}());
export { RoiSettingComponent };



// WEBPACK FOOTER //
// ./src/app/main/measure/content/roi-report/roi-setting/roi-setting.component.ts.pre-build-optimizer.js